import { Stack, Typography } from '@mui/material';
import { useState } from 'react';

export const ExpandableText = ({ text, maxLength = 100 }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleExpand = () => setIsExpanded((prev) => !prev);

  if (!text) return null;

  const displayText = isExpanded ? text : text.slice(0, maxLength) + (text.length > maxLength ? '...' : '');

  return (
    <Stack>
      <Typography
        component="h2"
        variant="subtitle2"
        sx={{
          fontWeight: 400,
          minWidth: '300px',
          width: '300px',
          maxWidth: '300px',
        }}
      >
        {displayText}
      </Typography>
      {text.length > maxLength && (
        <Typography
          component="span"
          variant="caption"
          sx={{ display: 'inline', cursor: 'pointer', color: 'primary.main' }}
          onClick={toggleExpand}
        >
          {isExpanded ? 'View Less' : 'View More'}
        </Typography>
      )}
    </Stack>
  );
};
